// extracted by mini-css-extract-plugin
export default {"root":"C_k1n","left":"n2tl_","right":"_3OPcU"};